import React from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import DashboardLandingPage from "../../components/candidate/dashboard/DashboardLandingPage";

function CandidateDashboard() {
  return (
    <div className="hirePlusPlusPageContent">
      <Sidebar activePage="dashboard" userRole="candidate" />
      <div className="w-full hireplusplusRightContent">
        <Topbar
          activePage="dashboard"
          userRole="candidate"
          noNavigate={true}
          driverFlag="dashboard"
          newTitle="Dashboard"
        />
        <DashboardLandingPage />
      </div>
    </div>
  );
}

export default CandidateDashboard;
